import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e0812ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "monitoring-menu__block" }
const _hoisted_2 = { key: 0 }

import { ChevronDownIcon, ClockIcon, Squares2X2Icon } from 'tir-style-system/icons/outline';
import { TirPmButton, TirPmButtonVariantEnum, TirPmButtonSizeEnum } from 'tir-components';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import MonitoringMenuItem from './monitoring-menu-item.vue';
import { MonitoringItemModel } from '../../models';
import { CalendarDaysIcon, TicketIcon } from 'tir-style-system/icons/outline';
import { useRouter } from 'vue-router';
import { MonitoringPagesEnum } from '../../../../pages/monitorings/enums';


export default /*#__PURE__*/_defineComponent({
  __name: 'monitoring-menu',
  props: {
  /** Открыто ли меню */
  isSidebarOpen: { type: Boolean },
  /** Показывать только иконки */
  showOnlyIcons: { type: Boolean },
},
  setup(__props) {

const props = __props;



const router = useRouter();

/**Находимся ли мы на старницах мониторинга */
const isMonitoringPage = computed(() =>
  Object.values(MonitoringPagesEnum).includes(
    router.currentRoute.value.name as MonitoringPagesEnum,
  ),
);

/**Открыто ли подменю блока мониторинга */
const isSubmenuOpen = ref(false);

/**Выбранный элемент меню мониторинга */
const selectedMonitoringElement = ref();

/**Пункты мониторинга */
const monitoringItems: Array<MonitoringItemModel> = [
  { Id: Date.now(), Title: 'По дням', Icon: CalendarDaysIcon, NameRouter: 'monitoring-days' },
  { Id: Date.now(), Title: 'По тикетам', Icon: TicketIcon, NameRouter: 'monitoring-tickets' },
  // { Id: Date.now(), Title: 'По проектам', Icon: Squares2X2Icon, NameRouter: 'monitoring-projects' },
];

/**Открыть подменю блока мониторинга  */
const toggleSubmenu = () => {
  isSubmenuOpen.value = !isSubmenuOpen.value;
};

watch(
  () => router.currentRoute.value.path,
  () => {
    if (isMonitoringPage.value) {
      selectedMonitoringElement.value = router.currentRoute.value.name;
      isSubmenuOpen.value = true;
    } else {
      selectedMonitoringElement.value = null;
    }
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["monitoring-menu__content", { 'monitoring-menu__content--close': !__props.isSidebarOpen }]),
      onDblclick: toggleSubmenu
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([{ 'monitoring-menu__title-block--open': __props.isSidebarOpen && !__props.showOnlyIcons }, "monitoring-menu__title-block"])
      }, [
        _createVNode(_unref(ClockIcon), { class: "monitoring-menu__icon" }),
        _createElementVNode("div", {
          class: _normalizeClass(["monitoring-menu__title", { 'monitoring-menu__title_visible': __props.isSidebarOpen && !__props.showOnlyIcons }])
        }, " Мониторинг ", 2),
        (__props.isSidebarOpen)
          ? (_openBlock(), _createBlock(_unref(TirPmButton), {
              key: 0,
              class: "monitoring-menu__chevron-button",
              variant: _unref(TirPmButtonVariantEnum).LinkState,
              size: _unref(TirPmButtonSizeEnum).Small
            }, {
              leftSlot: _withCtx(() => [
                _createVNode(_unref(ChevronDownIcon), {
                  class: _normalizeClass(["monitoring-menu__chevron-icon", { 'monitoring-menu__submenu-open': isSubmenuOpen.value }]),
                  onClick: toggleSubmenu
                }, null, 8, ["class"])
              ]),
              _: 1
            }, 8, ["variant", "size"]))
          : _createCommentVNode("", true)
      ], 2)
    ], 34),
    (isSubmenuOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(monitoringItems, (item) => {
            return _createVNode(MonitoringMenuItem, {
              active: selectedMonitoringElement.value === item.NameRouter,
              key: item.Id,
              menuItem: item,
              isSidebarOpen: __props.isSidebarOpen,
              showOnlyIcons: __props.showOnlyIcons
            }, null, 8, ["active", "menuItem", "isSidebarOpen", "showOnlyIcons"])
          }), 64))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})